import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Helpers } from '../../../helpers';
import { ScriptLoaderService } from '../../../_services/script-loader.service';


@Component({
selector: "default-page",
templateUrl: "./default.component.html",
encapsulation: ViewEncapsulation.None,
})
export class DefaultComponent implements OnInit {


constructor()  {

}
ngOnInit()  {

}



}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/default.component.ts